import React, { Component } from 'react';
import { Form, Modal, Button, message, Skeleton, Alert, Tooltip, Icon, Row, Col, Input, Divider } from 'antd';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';

import { getPropertiesByHostId } from 'utils/apis/property';
import { createCalendarBookmark, deleteCalendarBookmark, getCalendarBookmark, patchPinCalendarBookmark } from 'utils/apis/bookmark';
import { getConstants } from 'utils/apis/constants';
import { getRoomTypesByProperty, getUnitsByRoomType, updateCalendarBulk } from 'utils/apis/multiCalendar';
import { DATE_FORMAT } from 'utils/constants';
import intl from 'react-intl-universal';

import queryString from 'query-string';
import MCRateUpdateBody from './components/MCRateUpdateBody/MCRateUpdateBody';
import BulkMCRateUpdateBody from './components/BulkMCRateUpdateBody/BulkMCRateUpdateBody';
import BulkMCRateUpdate from './components/BulkMCRateUpdate/BulkMCRateUpdate';

const FormItem = Form.Item;

class BookmarkModalFormInner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicSelectionItems: [0],
      nextSelectionIndex: 1
    };
  }

  handleOnRoomTypeChange = (roomTypeIds, index) => {
    const { form, roomTypesWithRatesAndUnits } = this.props;
    const selectedRoomTypes = roomTypeIds.map(roomTypeId => roomTypesWithRatesAndUnits.find(roomType => roomType.id === roomTypeId)).filter(Boolean);
    const allUnits = selectedRoomTypes.flatMap(roomType => roomType.units || []);
    const selectedUnitIds = form.getFieldValue('unitsApplied' + index) || [];
    const filteredUnitIds = selectedUnitIds.filter(unitId => allUnits.some(unit => unit.id === unitId));
    const selectedUnits = filteredUnitIds.map(unitId => allUnits.find(unit => unit.id === unitId)).filter(Boolean);

    this.setState({
      ['allUnits' + index]: allUnits,
      ['selectedRoomTypes' + index]: selectedRoomTypes,
      ['selectedUnits' + index]: selectedUnits
    });

    form.setFieldsValue({
      ['unitsApplied' + index]: filteredUnitIds
    });
  };

  handleOnUnitChange = (unitIds, index) => {
    const allUnits = this.state['allUnits' + index] || [];
    const selectedUnits = unitIds.map(unitId => allUnits.find(unit => unit.id === unitId)).filter(Boolean);
    this.setState({
      ['selectedUnits' + index]: selectedUnits
    });
  };

  selectAllRoomTypes = index => {
    const { form, roomTypesWithRatesAndUnits } = this.props;
    const allUnits = roomTypesWithRatesAndUnits.flatMap(roomType => roomType.units || []);

    this.setState({
      ['allUnits' + index]: allUnits,
      ['selectedRoomTypes' + index]: roomTypesWithRatesAndUnits,
      ['selectedUnits' + index]: []
    });

    form.setFieldsValue({
      ['roomTypesApplied' + index]: roomTypesWithRatesAndUnits.map(roomType => roomType.id),
      ['unitsApplied' + index]: []
    });
  };

  clearAllRoomTypes = index => {
    const { form } = this.props;
    form.setFieldsValue({
      ['roomTypesApplied' + index]: [],
      ['unitsApplied' + index]: []
    });
    this.setState({
      ['allUnits' + index]: [],
      ['selectedRoomTypes' + index]: [],
      ['selectedUnits' + index]: []
    });
  };

  selectAllUnits = index => {
    const { form } = this.props;
    const allUnits = this.state['allUnits' + index] || [];
    this.setState({
      ['selectedUnits' + index]: allUnits
    });
    form.setFieldsValue({
      ['unitsApplied' + index]: allUnits.map(unit => unit.id)
    });
  };

  clearAllUnits = index => {
    const { form } = this.props;
    this.setState({
      ['selectedUnits' + index]: []
    });
    form.setFieldsValue({
      ['unitsApplied' + index]: []
    });
  };

  addSelectionItem = () => {
    this.setState(prevState => ({
      dynamicSelectionItems: [...prevState.dynamicSelectionItems, prevState.nextSelectionIndex],
      nextSelectionIndex: prevState.nextSelectionIndex + 1
    }));
  };

  removeSelectionItem = removeIndex => {
    const { form } = this.props;
    const { dynamicSelectionItems } = this.state;
    if (dynamicSelectionItems.length <= 1) {
      return;
    }

    const filteredItems = dynamicSelectionItems.filter(itemIndex => itemIndex !== removeIndex);
    const nextState = {
      dynamicSelectionItems: filteredItems.map((item, index) => index),
      nextSelectionIndex: filteredItems.length
    };
    const resetFields = [];
    const newFormValues = {};

    dynamicSelectionItems.forEach((itemIndex, currentIndex) => {
      resetFields.push('roomTypesApplied' + currentIndex, 'unitsApplied' + currentIndex);
    });

    filteredItems.forEach((itemIndex, newIndex) => {
      const sourceRoomTypes = form.getFieldValue('roomTypesApplied' + itemIndex) || [];
      const sourceUnits = form.getFieldValue('unitsApplied' + itemIndex) || [];
      const sourceAllUnits = this.state['allUnits' + itemIndex] || [];
      const sourceSelectedRoomTypes = this.state['selectedRoomTypes' + itemIndex] || [];
      const sourceSelectedUnits = this.state['selectedUnits' + itemIndex] || [];

      newFormValues['roomTypesApplied' + newIndex] = sourceRoomTypes;
      newFormValues['unitsApplied' + newIndex] = sourceUnits;
      nextState['allUnits' + newIndex] = sourceAllUnits;
      nextState['selectedRoomTypes' + newIndex] = sourceSelectedRoomTypes;
      nextState['selectedUnits' + newIndex] = sourceSelectedUnits;
    });

    form.resetFields(resetFields);
    this.setState(nextState, () => {
      form.setFieldsValue(newFormValues);
    });
  };

  render() {
    const { form, roomTypesWithRatesAndUnits, rateTypes, currency, timezone } = this.props;
    const { dynamicSelectionItems } = this.state;

    return (
      <Form layout="vertical">
        <FormItem label="Bookmark Name">
          {form.getFieldDecorator('bookmarkName', {
            rules: [
              { required: true, message: 'Please input bookmark name' },
              {
                validator: (rule, value, callback) => {
                  if (value && !value.trim()) {
                    callback('Please input bookmark name');
                    return;
                  }
                  callback();
                }
              }
            ]
          })(<Input placeholder="Enter bookmark name" maxLength={100} />)}
        </FormItem>
        {dynamicSelectionItems.map((itemIndex, index) => (
          <div key={itemIndex}>
            <Divider />
            <div style={{ fontWeight: 500, marginBottom: 8 }}>Selection {index + 1}</div>
            <BulkMCRateUpdate
              type="roomType"
              index={index}
              selectAllButtonId={`select-all-bookmark-room-types-${index}`}
              clearAllButtonId={`clear-all-bookmark-room-types-${index}`}
              requiredErrorMessage="Please select room types"
              form={form}
              items={roomTypesWithRatesAndUnits}
              selectedItems={this.state['selectedRoomTypes' + index] || []}
              rateTypes={rateTypes}
              onSelectionChange={this.handleOnRoomTypeChange}
              onSelectAll={() => this.selectAllRoomTypes(index)}
              onClearAll={() => this.clearAllRoomTypes(index)}
              currency={currency}
              timezone={timezone}
              hideRateTable
            />
            <BulkMCRateUpdate
              type="unit"
              index={index}
              selectAllButtonId={`select-all-bookmark-units-${index}`}
              clearAllButtonId={`clear-all-bookmark-units-${index}`}
              requiredErrorMessage="Please select units"
              form={form}
              items={this.state['allUnits' + index] || []}
              selectedItems={this.state['selectedUnits' + index] || []}
              rateTypes={rateTypes}
              onSelectionChange={this.handleOnUnitChange}
              onSelectAll={() => this.selectAllUnits(index)}
              onClearAll={() => this.clearAllUnits(index)}
              currency={currency}
              timezone={timezone}
              selectedRoomTypes={this.state['selectedRoomTypes' + index] || []}
              hideRateTable
            />
            {dynamicSelectionItems.length > 1 && (
              <Button type="dashed" style={{ marginTop: 8, color: 'red', borderColor: 'red' }} onClick={() => this.removeSelectionItem(itemIndex)}>
                Remove Selection
              </Button>
            )}
            <div style={{ marginBottom: 16 }} />
          </div>
        ))}
        <Button
          style={{
            color: dynamicSelectionItems.length >= 10 ? '#d9d9d9' : '#00b9c6',
            borderColor: dynamicSelectionItems.length >= 10 ? '#d9d9d9' : '#00b9c6'
          }}
          onClick={this.addSelectionItem}
          disabled={dynamicSelectionItems.length >= 10}
        >
          Add Selection
        </Button>
      </Form>
    );
  }
}

const BookmarkModalForm = Form.create({ name: 'bookmarkModalForm' })(BookmarkModalFormInner);

BookmarkModalFormInner.propTypes = {
  form: PropTypes.object.isRequired,
  roomTypesWithRatesAndUnits: PropTypes.array.isRequired,
  rateTypes: PropTypes.array.isRequired,
  currency: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired
};

class MCModalRateUpdateWizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      isRateLoading: false,
      isDataSaveBefore: false,
      daysOfWeek: [],
      rates: [],
      rateTypes: [],
      selectedDays: [],
      selectedPropertyName: '',
      isBookmarkModalVisible: false,
      bookmarks: [],
      bookmarkApplyRequest: null,
      bookmarkAllUnits: [],
      bookmarkSelectedRoomTypes: [],
      bookmarkSelectedUnits: []
    };
    this.bookmarkModalFormRef = null;
  }

  componentDidMount = async () => {
    this.setDataValue();
    await this.fetchAndSetRateData();
    await this.fetchCalendarBookmarks();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedPropertyId !== this.props.selectedPropertyId) {
      this.setDataValue();
      this.fetchAndSetRateData();
      this.fetchCalendarBookmarks();
    }
  }

  getQueryHostId = () => {
    const parsedQuery = queryString.parse(window.location.search);
    return parsedQuery.host || parsedQuery.hostId || '';
  };

  normalizeBookmarkSelections = rawBookmarks => {
    if (!Array.isArray(rawBookmarks) || rawBookmarks.length === 0) {
      return [];
    }

    return rawBookmarks.map(bookmark => {
      const roomTypeIds = bookmark.roomTypeIds
        ? [bookmark.roomTypeIds].flat().filter(Boolean)
        : [bookmark.roomTypeId || bookmark.roomType].flat().filter(Boolean);
      const unitIds = bookmark.unitIds ? [bookmark.unitIds].flat().filter(Boolean) : [bookmark.unitId || bookmark.unit].flat().filter(Boolean);

      return { roomTypeIds, unitIds };
    });
  };

  mapApiBookmarkToLocal = apiBookmark => {
    const selections =
      Array.isArray(apiBookmark && apiBookmark.selections) && apiBookmark.selections.length > 0
        ? apiBookmark.selections
        : this.normalizeBookmarkSelections(apiBookmark && apiBookmark.bookmarks);
    const roomTypeIds = Array.from(new Set(selections.flatMap(selection => selection.roomTypeIds || []).filter(Boolean)));
    const unitIds = Array.from(new Set(selections.flatMap(selection => selection.unitIds || []).filter(Boolean)));

    return {
      id: apiBookmark._id || apiBookmark.id,
      key: apiBookmark._id || apiBookmark.id || `${Date.now()}`,
      isPinned: !!apiBookmark.isPinned,
      name: apiBookmark.bookmarkName || apiBookmark.name || '',
      selections,
      roomTypeIds,
      roomTypeNames: [],
      unitIds,
      unitNames: []
    };
  };

  fetchCalendarBookmarks = async () => {
    const { selectedPropertyId } = this.props;
    if (!selectedPropertyId) {
      this.setState({ bookmarks: [] });
      return;
    }

    try {
      const bookmarks = await getCalendarBookmark({ property: selectedPropertyId });
      const normalizedBookmarks = Array.isArray(bookmarks) ? bookmarks.map(this.mapApiBookmarkToLocal) : [];

      this.setState({
        bookmarks: this.reorderPinnedBookmarks(normalizedBookmarks)
      });
    } catch (error) {
      message.error(error.message || 'Failed to load bookmarks');
    }
  };

  fetchAndSetRateData = async () => {
    const { selectedPropertyId, selectedRateFilters } = this.props;

    const monthStartDate = moment().format(DATE_FORMAT);
    const monthEndDate = moment()
      .add(1, 'day')
      .format(DATE_FORMAT);

    this.setState({
      isRateLoading: true
    });

    const formattedRoomTypeAndUnitRates = await getRoomTypesByProperty(selectedPropertyId, monthStartDate, monthEndDate, selectedRateFilters)
      .then(roomTypes => {
        return Promise.all(
          roomTypes.map(async roomType => {
            const filteredRoomTypeRates = Object.entries(roomType.rates).filter(rate => {
              return rate[1].length > 0;
            });

            let filteredRoomTypeRateArr = [];
            if (filteredRoomTypeRates && filteredRoomTypeRates.length > 0) {
              const filteredRoomTypeRatesData = filteredRoomTypeRates
                .map(filteredRoomTypeRate => {
                  const [source, roomTypeRates] = filteredRoomTypeRate;
                  if (source === 'web' && roomTypeRates.length > 1) {
                    return [roomTypeRates[0]].map(rate => {
                      return {
                        id: rate._id,
                        name: rate.name,
                        source,
                        isDerived: rate.isDerived,
                        calculation: rate.calculation
                      };
                    });
                  }
                  return roomTypeRates.map(rate => {
                    return {
                      id: rate._id,
                      name: rate.name,
                      source,
                      isDerived: rate.isDerived,
                      calculation: rate.calculation
                    };
                  });
                })
                .flat()
                .reduce((combinedRoomTypeRates, roomTypeRate) => {
                  const existingRate = combinedRoomTypeRates.find(rate => {
                    return rate.id === roomTypeRate.id;
                  });
                  if (existingRate) {
                    existingRate.sources.push(roomTypeRate.source);
                    existingRate.isDerived = existingRate.isDerived || roomTypeRate.isDerived;
                    return combinedRoomTypeRates;
                  } else {
                    const newRoomTypeRate = { ...roomTypeRate, sources: [roomTypeRate.source] };
                    return [...combinedRoomTypeRates, newRoomTypeRate];
                  }
                }, []);
              filteredRoomTypeRateArr.push(...filteredRoomTypeRatesData);
            }

            const formattedUnitData = await getUnitsByRoomType(roomType._id, monthStartDate, monthEndDate, selectedRateFilters, 1, 350).then(
              units => {
                return units.data
                  .map(unit => {
                    const filteredUnitRates = Object.entries(unit.rates).filter(rate => {
                      return rate[1].length > 0;
                    });

                    if (filteredUnitRates && filteredUnitRates.length > 0) {
                      const formattedUnitRates = filteredUnitRates
                        .map(filteredUnitRate => {
                          const [source, unitRates] = filteredUnitRate;
                          if (source === 'web' && unitRates.length > 1) {
                            return [unitRates[0]].map(unitRate => {
                              return {
                                id: unitRate._id,
                                name: unitRate.name,
                                source: source,
                                isDerived: unitRate.isDerived,
                                calculation: unitRate.calculation
                              };
                            });
                          }
                          return unitRates.map(unitRate => {
                            return {
                              id: unitRate._id,
                              name: unitRate.name,
                              source: source,
                              isDerived: unitRate.isDerived,
                              calculation: unitRate.calculation
                            };
                          });
                        })
                        .flat()
                        .reduce((combinedUnitRates, unitRate) => {
                          const existingRate = combinedUnitRates.find(rate => rate.id === unitRate.id);
                          if (existingRate) {
                            existingRate.sources.push(unitRate.source);
                            existingRate.isDerived = existingRate.isDerived || unitRate.isDerived;
                            return combinedUnitRates;
                          } else {
                            const newUnitRate = { ...unitRate, sources: [unitRate.source] };
                            return [...combinedUnitRates, newUnitRate];
                          }
                        }, []);
                      return {
                        id: unit._id,
                        name: unit.name,
                        roomType: roomType._id,
                        rates: formattedUnitRates
                      };
                    }
                    return undefined;
                  })
                  .filter(unit => !!unit);
              }
            );
            const roomTypeData = {
              id: roomType._id,
              name: roomType.name,
              units: formattedUnitData,
              rates: filteredRoomTypeRateArr
            };

            return roomTypeData;
          })
        );
      })
      .catch(err => message.error(err.message));
    this.setState({
      isRateLoading: false,
      rates: formattedRoomTypeAndUnitRates
    });
  };

  setDataValue = async () => {
    const { selectedPropertyId } = this.props;
    const queryHostId = queryString.parse(window.location.search).host || queryString.parse(window.location.search).hostId;
    // const propertyPromise = getProperties()
    const propertyPromise = getPropertiesByHostId(queryHostId) // Optimized by sending hostId instead of getting all properties
      .then(properties => {
        if (properties.length > 0) {
          const property = properties.filter(property => String(property._id) === String(selectedPropertyId));
          if (property.length > 0) {
            return property[0].name;
          }
        }
      })
      .catch(() => {
        message.error('Failed to load properties');
        return '';
      });

    const daysOfWeekPromise = getConstants('daysOfWeek').then(resDaysOfWeekPromise => {
      return Object.keys(resDaysOfWeekPromise.data).map(k => resDaysOfWeekPromise.data[k]);
    });

    const rateTypesPromise = getConstants('rateTypesName').then(resRateTypesPromise => {
      return Object.keys(resRateTypesPromise.data).map(k => resRateTypesPromise.data[k]);
    });

    const [selectedPropertyName, daysOfWeekConstant, rateTypes] = await Promise.all([propertyPromise, daysOfWeekPromise, rateTypesPromise]);

    const daysOfWeek = daysOfWeekConstant.map(day => {
      return { ...day, value: Number(day.code) };
    });

    const selectedDays = daysOfWeekConstant.map(day => Number(day.code));

    this.setState({
      selectedPropertyName,
      daysOfWeek,
      rateTypes,
      selectedDays
    });
  };

  handleSelectedDayChange = selectedDays => {
    this.setState({
      selectedDays
    });
  };

  handleOnSubmit = shouldCloseModal => e => {
    e.preventDefault();
    const { form, isBulkShow } = this.props;
    const onOkAction = this.handleOnConfirmSubmit(shouldCloseModal);
    const onOkActionBulk = this.handleOnConfirmSubmitBulk(shouldCloseModal);

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        Modal.confirm({
          title: intl.get('multicalendar.message.updateRateTitle').d('Do you want to update these calendar rates?'),
          content: intl.get('multicalendar.message.updateRateContent').d('Only rates that had been modifed will be affected.'),
          onOk() {
            if (isBulkShow) {
              return onOkActionBulk(values);
            } else {
              return onOkAction(values);
            }
          },
          onCancel() {}
        });
      }
    });
  };

  handleOnConfirmSubmit = shouldCloseModal => async formValues => {
    const { onSuccess } = this.props;
    const { rates, selectedDays } = this.state;
    const { dateRange, roomTypesApplied, roomTypesRate, unitsApplied, unitsRate } = formValues;

    if (!!roomTypesApplied) {
      this.setState({
        isSaving: true
      });

      const roomTypePayload = [];
      const unitPayload = [];

      const defaultPayload = {
        startDate: dateRange[0].format(DATE_FORMAT),
        endDate: dateRange[1].format(DATE_FORMAT),
        selectedDays
      };

      const foundRoomTypes = rates.filter(roomType => roomTypesApplied.includes(roomType.id));

      for (let i = 0; i < foundRoomTypes.length; i++) {
        const foundRoomType = foundRoomTypes[i];

        for (let j = 0; j < foundRoomType.rates.length; j++) {
          const rate = foundRoomType.rates[j];

          if (!rate.isDerived) {
            const price = roomTypesRate[rate.source];

            if (!!price) {
              roomTypePayload.push({ ...defaultPayload, roomTypeId: foundRoomType.id, rateId: rate.id, price });
            }
          }
        }
      }

      const appliedUnits = foundRoomTypes
        .map(foundRoomType => foundRoomType.units)
        .flat()
        .filter(unit => unitsApplied.includes(unit.id));

      for (let i = 0; i < appliedUnits.length; i++) {
        const unit = appliedUnits[i];

        for (let j = 0; j < unit.rates.length; j++) {
          const rate = unit.rates[j];

          if (!rate.isDerived) {
            const price = unitsRate[rate.source];

            if (!!price) {
              unitPayload.push({ ...defaultPayload, unitId: unit.id, rateId: rate.id, price });
            }
          }
        }
      }

      updateCalendarBulk([...roomTypePayload, ...unitPayload])
        .then(() => {
          this.setState({ isSaving: false, isDataSaveBefore: true });
          shouldCloseModal && onSuccess();
          message.success(intl.get('multicalendar.message.updateRateSuccess').d('Successfully updated Calendar Rates!'));
        })
        .catch(e => message.error(e.message));
    } else {
      if (shouldCloseModal && this.props.onCancel) {
        this.props.onCancel();
      }
    }
  };

  handleOnConfirmSubmitBulk = shouldCloseModal => async formValues => {
    const { onSuccess } = this.props;
    const { rates, selectedDays } = this.state;

    this.setState({
      isSaving: true
    });

    const filterDateRange = Object.keys(formValues)
      .filter(key => key.startsWith('dateRange'))
      .map(key => ({
        filterDateRange: formValues[key]
      }));

    const filterSelectedDays = Object.keys(formValues)
      .filter(key => key.startsWith('selectedDays'))
      .map(key => ({
        filterSelectedDays: formValues[key]
      }));

    const filterRoomTypesApplied = Object.keys(formValues)
      .filter(key => key.startsWith('roomTypesApplied'))
      .map(key => ({
        filterRoomTypesApplied: formValues[key]
      }));

    const filterUnitsApplied = Object.keys(formValues)
      .filter(key => key.startsWith('unitsApplied'))
      .map(key => ({
        filterUnitsApplied: formValues[key]
      }));

    // const filterRoomTypesRate = Object.keys(formValues)
    //   .filter(key => key.startsWith('roomTypesRate'))
    //   .map(key => ({
    //     filterRoomTypesRate: formValues[key]
    //   }));

    // console.log('filterRoomTypesRate', filterRoomTypesRate);

    // Transform roomTypesRate entries into the desired format
    const transformRoomTypesRate = () => {
      // Group entries by index
      const groupedByIndex = {};

      Object.entries(formValues.roomTypesRate || {}).forEach(([key, value]) => {
        // Extract source and index (e.g., "web0" -> source: "web", index: "0")
        const match = key.match(/([a-zA-Z]+)(\d+)/);
        if (match) {
          const [, source, index] = match;

          if (!groupedByIndex[index]) {
            groupedByIndex[index] = {};
          }

          groupedByIndex[index][source] = value;
        }
      });

      // Convert grouped object to array format
      return Object.values(groupedByIndex).map(group => group);
    };

    const filterRoomTypesRate = transformRoomTypesRate();

    // Transform unitsRate entries into the desired format
    const transformUnitsRate = () => {
      // Group entries by index
      const groupedByIndex = {};

      Object.entries(formValues.unitsRate || {}).forEach(([key, value]) => {
        // Extract source and index (e.g., "web0" -> source: "web", index: "0")
        const match = key.match(/([a-zA-Z]+)(\d+)/);
        if (match) {
          const [, source, index] = match;

          if (!groupedByIndex[index]) {
            groupedByIndex[index] = {};
          }

          groupedByIndex[index][source] = value;
        }
      });

      // Convert grouped object to array format
      return Object.values(groupedByIndex).map(group => group);
    };

    const filterUnitsRate = transformUnitsRate();

    const filterDaysAndDateSelected = filterDateRange.map((dateRangeObj, index) => {
      const dateRange = dateRangeObj.filterDateRange;
      const selectedDays = (filterSelectedDays[index] && filterSelectedDays[index].filterSelectedDays) || [];

      const startDate = moment(dateRange[0]);
      const endDate = moment(dateRange[1]);
      const matchingDates = [];

      // Create a copy of the start date to avoid modifying the original
      const currentDate = moment(startDate);

      // Iterate through each day in the date range
      while (currentDate.isSameOrBefore(endDate)) {
        // Use moment's native day numbering where 0=Sunday
        const dayOfWeek = currentDate.day();

        if (selectedDays.includes(dayOfWeek)) {
          // Add the date in DD-MM-YYYY format
          matchingDates.push(currentDate.format('DD-MM-YYYY'));
        }

        // Move to the next day
        currentDate.add(1, 'days');
      }

      return {
        filterDayAndDateSelected: matchingDates
      };
    });

    // Check for overlapping dates and room types
    const checkOverlaps = () => {
      // Find dates that appear in multiple ranges
      const dateToRanges = {};

      filterDaysAndDateSelected.forEach((dateObj, rangeIndex) => {
        dateObj.filterDayAndDateSelected.forEach(date => {
          if (!dateToRanges[date]) {
            dateToRanges[date] = new Set();
          }
          dateToRanges[date].add(rangeIndex);
        });
      });

      // Find overlapping date ranges
      const overlappingRangePairs = [];

      Object.values(dateToRanges).forEach(rangeSet => {
        if (rangeSet.size > 1) {
          const rangeArray = Array.from(rangeSet);
          for (let i = 0; i < rangeArray.length; i++) {
            for (let j = i + 1; j < rangeArray.length; j++) {
              overlappingRangePairs.push([rangeArray[i], rangeArray[j]]);
            }
          }
        }
      });

      // Check if any pair has overlapping room types
      for (const [rangeIndex1, rangeIndex2] of overlappingRangePairs) {
        const roomTypes1 = (filterRoomTypesApplied[rangeIndex1] && filterRoomTypesApplied[rangeIndex1].filterRoomTypesApplied) || [];
        const roomTypes2 = (filterRoomTypesApplied[rangeIndex2] && filterRoomTypesApplied[rangeIndex2].filterRoomTypesApplied) || [];

        const hasRoomTypeOverlap = roomTypes1.some(roomType => roomTypes2.includes(roomType));

        if (hasRoomTypeOverlap) {
          // Check rates for duplicates
          const rates1 = filterRoomTypesRate[rangeIndex1] || {};
          const rates2 = filterRoomTypesRate[rangeIndex2] || {};

          // Compare sources that have values in both ranges
          for (const source in rates1) {
            if (rates1[source] !== undefined && rates1[source] !== null && rates2[source] !== undefined && rates2[source] !== null) {
              // Both ranges have values for the same source
              Modal.error({
                width: 600,
                title: 'Rate Conflict Detected',
                content: (
                  <>
                    - Overlapping date ranges with duplicate room type rates detected.
                    <br />- For source "{source}" has been crash with "{rates1[source]} and {rates2[source]}".
                    <br />- Please ensure only one rate is set for overlapping dates.
                  </>
                )
              });
              // message.error(
              //   intl
              //     .get('multicalendar.message.duplicateRateError')
              //     .d(
              //       `Overlapping date ranges with duplicate room type rates detected for source "${source}" has been crash with "${rates1[source]} and ${rates2[source]}". Please ensure only one rate is set for overlapping dates.`
              //     )
              // );
              this.setState({ isSaving: false });
              return false;
            }
          }
        }
      }
      return true;
    };

    if (!checkOverlaps()) {
      return;
    }

    // Check for overlapping dates and units with duplicate rates
    const checkUnitOverlaps = () => {
      // Find dates that appear in multiple ranges
      const dateToRanges = {};

      filterDaysAndDateSelected.forEach((dateObj, rangeIndex) => {
        dateObj.filterDayAndDateSelected.forEach(date => {
          if (!dateToRanges[date]) {
            dateToRanges[date] = new Set();
          }
          dateToRanges[date].add(rangeIndex);
        });
      });

      // Find overlapping date ranges
      const overlappingRangePairs = [];

      Object.values(dateToRanges).forEach(rangeSet => {
        if (rangeSet.size > 1) {
          const rangeArray = Array.from(rangeSet);
          for (let i = 0; i < rangeArray.length; i++) {
            for (let j = i + 1; j < rangeArray.length; j++) {
              overlappingRangePairs.push([rangeArray[i], rangeArray[j]]);
            }
          }
        }
      });

      // Check if any pair has overlapping units
      for (const [rangeIndex1, rangeIndex2] of overlappingRangePairs) {
        const units1 = (filterUnitsApplied[rangeIndex1] && filterUnitsApplied[rangeIndex1].filterUnitsApplied) || [];
        const units2 = (filterUnitsApplied[rangeIndex2] && filterUnitsApplied[rangeIndex2].filterUnitsApplied) || [];

        const hasUnitOverlap = units1.some(unit => units2.includes(unit));

        if (hasUnitOverlap) {
          // Check rates for duplicates
          const rates1 = filterUnitsRate[rangeIndex1] || {};
          const rates2 = filterUnitsRate[rangeIndex2] || {};

          // Compare sources that have values in both ranges
          for (const source in rates1) {
            if (rates1[source] !== undefined && rates1[source] !== null && rates2[source] !== undefined && rates2[source] !== null) {
              // Both ranges have values for the same source
              Modal.error({
                width: 600,
                title: 'Rate Conflict Detected',
                content: (
                  <>
                    - Overlapping date ranges with duplicate unit rates detected.
                    <br />- For source "{source}" has been crash with "{rates1[source]} and {rates2[source]}".
                    <br />- Please ensure only one rate is set for overlapping dates.
                  </>
                )
              });
              // message.error(
              //   intl
              //     .get('multicalendar.message.duplicateUnitRateError')
              //     .d(
              //       `Overlapping date ranges with duplicate unit rates detected for source "${source}" has been crash with "${rates1[source]} and ${rates2[source]}". Please ensure only one rate is set for overlapping dates.`
              //     )
              // );
              this.setState({ isSaving: false });
              return false;
            }
          }
        }
      }
      return true;
    };

    if (!checkUnitOverlaps()) {
      return;
    }

    // Check for dates that appear in multiple date ranges
    const dateOccurrences = {};
    filterDaysAndDateSelected.forEach((dateObj, rangeIndex) => {
      dateObj.filterDayAndDateSelected.forEach(date => {
        if (!dateOccurrences[date]) {
          dateOccurrences[date] = [];
        }
        dateOccurrences[date].push(rangeIndex);
      });
    });

    // Find overlapping date ranges and check if they have duplicate units
    let hasDuplicateUnitsInOverlappingDates = false;
    Object.entries(dateOccurrences).forEach(([date, rangeIndices]) => {
      if (rangeIndices.length > 1) {
        // This date appears in multiple ranges
        const unitsForOverlappingDate = [];

        // Collect all units from date ranges that include this date
        rangeIndices.forEach(rangeIndex => {
          const units = (filterUnitsApplied[rangeIndex] && filterUnitsApplied[rangeIndex].filterUnitsApplied) || [];
          const formattedUnits = Array.isArray(units) ? units : units ? [units] : [];
          unitsForOverlappingDate.push(...formattedUnits);
        });

        // Check if the same unit appears multiple times in the overlapping date ranges
        const uniqueUnits = new Set(unitsForOverlappingDate);
        if (unitsForOverlappingDate.length !== uniqueUnits.size) {
          hasDuplicateUnitsInOverlappingDates = true;
        }
      }
    });

    if (hasDuplicateUnitsInOverlappingDates) {
      message.error(
        intl
          .get('multicalendar.message.duplicateError')
          .d('Overlapping date ranges and days with duplicate units detected. Please ensure date ranges or unit selections do not overlap.')
      );
      this.setState({ isSaving: false });
      return;
    }

    const roomTypePayload = [];
    const unitPayload = [];

    // Process each date range
    for (let rangeIndex = 0; rangeIndex < filterRoomTypesApplied.length; rangeIndex++) {
      // Get the selected room types for this range
      const roomTypesForRange = (filterRoomTypesApplied[rangeIndex] && filterRoomTypesApplied[rangeIndex].filterRoomTypesApplied) || [];

      // Get date information for this range
      const dateRange = filterDateRange[rangeIndex] && filterDateRange[rangeIndex].filterDateRange;
      const matchingDates = (filterDaysAndDateSelected[rangeIndex] && filterDaysAndDateSelected[rangeIndex].filterDayAndDateSelected) || [];

      if (!roomTypesForRange.length || !matchingDates.length) continue;

      // Create base payload for this date range
      const rangePayload = {
        startDate: moment(dateRange[0]).format(DATE_FORMAT),
        endDate: moment(dateRange[1]).format(DATE_FORMAT),
        selectedDays: (filterSelectedDays[rangeIndex] && filterSelectedDays[rangeIndex].filterSelectedDays) || selectedDays
      };

      // Find room types that match the selection
      const foundRoomTypes = rates.filter(roomType => roomTypesForRange.includes(roomType.id));

      // Process room type rates
      for (const foundRoomType of foundRoomTypes) {
        for (const rate of foundRoomType.rates) {
          if (!rate.isDerived) {
            const sourceRates = filterRoomTypesRate[rangeIndex] || {};
            const price = sourceRates[rate.source];

            if (price !== undefined && price !== null) {
              roomTypePayload.push({
                ...rangePayload,
                roomTypeId: foundRoomType.id,
                rateId: rate.id,
                price
              });
            }
          }
        }
      }

      // Process unit rates
      const unitsForRange = (filterUnitsApplied[rangeIndex] && filterUnitsApplied[rangeIndex].filterUnitsApplied) || [];
      if (unitsForRange.length) {
        const appliedUnits = foundRoomTypes
          .map(roomType => roomType.units)
          .flat()
          .filter(unit => unitsForRange.includes(unit.id));

        for (const unit of appliedUnits) {
          for (const rate of unit.rates) {
            if (!rate.isDerived) {
              const sourceRates = filterUnitsRate[rangeIndex] || {};
              const price = sourceRates[rate.source];

              if (price !== undefined && price !== null) {
                unitPayload.push({
                  ...rangePayload,
                  unitId: unit.id,
                  rateId: rate.id,
                  price
                });
              }
            }
          }
        }
      }
    }

    updateCalendarBulk([...roomTypePayload, ...unitPayload])
      .then(() => {
        this.setState({ isSaving: false, isDataSaveBefore: true });
        shouldCloseModal && onSuccess();
        message.success(intl.get('multicalendar.message.updateRateSuccess').d('Successfully updated Calendar Rates!'));
      })
      .catch(e => message.error(e.message));
    // } else {
    //   shouldCloseModal && onCancel();
    // }
  };

  handleOnCancel = () => {
    const { isDataSaveBefore } = this.state;
    const { onSuccess, onCancel } = this.props;
    if (isDataSaveBefore) {
      // So we can properly reload data after user click cancel if data was saved before
      onSuccess();
    } else {
      onCancel();
    }
  };

  setBookmarkModalFormRef = ref => {
    if (ref && ref.props && ref.props.form) {
      this.bookmarkModalFormRef = ref.props.form;
    }
  };

  resetBookmarkModalForm = () => {
    if (this.bookmarkModalFormRef) {
      this.bookmarkModalFormRef.resetFields();
    }
    this.setState({
      bookmarkAllUnits: [],
      bookmarkSelectedRoomTypes: [],
      bookmarkSelectedUnits: []
    });
  };

  showBookmarkModal = () => {
    this.setState({
      isBookmarkModalVisible: true
    });
  };

  hideBookmarkModal = () => {
    this.setState({
      isBookmarkModalVisible: false
    });
    this.resetBookmarkModalForm();
  };

  handleBookmarkRoomTypeChange = roomTypeIds => {
    const { rates } = this.state;
    const selectedRoomTypes = roomTypeIds.map(roomTypeId => rates.find(roomType => roomType.id === roomTypeId)).filter(Boolean);
    const allUnits = selectedRoomTypes.flatMap(roomType => roomType.units || []);
    const selectedUnitIds = (this.bookmarkModalFormRef && this.bookmarkModalFormRef.getFieldValue('unitsApplied')) || [];
    const filteredUnitIds = selectedUnitIds.filter(unitId => allUnits.some(unit => unit.id === unitId));
    const selectedUnits = filteredUnitIds.map(unitId => allUnits.find(unit => unit.id === unitId)).filter(Boolean);

    this.setState({
      bookmarkAllUnits: allUnits,
      bookmarkSelectedRoomTypes: selectedRoomTypes,
      bookmarkSelectedUnits: selectedUnits
    });

    if (this.bookmarkModalFormRef) {
      this.bookmarkModalFormRef.setFieldsValue({
        unitsApplied: filteredUnitIds
      });
    }
  };

  handleBookmarkUnitChange = unitIds => {
    const { bookmarkAllUnits } = this.state;
    const selectedUnits = unitIds.map(unitId => bookmarkAllUnits.find(unit => unit.id === unitId)).filter(Boolean);
    this.setState({
      bookmarkSelectedUnits: selectedUnits
    });
  };

  selectAllBookmarkRoomTypes = () => {
    const { rates } = this.state;
    const allUnits = rates.flatMap(roomType => roomType.units || []);

    this.setState({
      bookmarkAllUnits: allUnits,
      bookmarkSelectedRoomTypes: rates,
      bookmarkSelectedUnits: []
    });

    if (this.bookmarkModalFormRef) {
      this.bookmarkModalFormRef.setFieldsValue({
        roomTypesApplied: rates.map(roomType => roomType.id),
        unitsApplied: []
      });
    }
  };

  clearAllBookmarkRoomTypes = () => {
    this.setState({
      bookmarkAllUnits: [],
      bookmarkSelectedRoomTypes: [],
      bookmarkSelectedUnits: []
    });

    if (this.bookmarkModalFormRef) {
      this.bookmarkModalFormRef.setFieldsValue({
        roomTypesApplied: [],
        unitsApplied: []
      });
    }
  };

  selectAllBookmarkUnits = () => {
    const { bookmarkAllUnits } = this.state;
    this.setState({
      bookmarkSelectedUnits: bookmarkAllUnits
    });

    if (this.bookmarkModalFormRef) {
      this.bookmarkModalFormRef.setFieldsValue({
        unitsApplied: bookmarkAllUnits.map(unit => unit.id)
      });
    }
  };

  clearAllBookmarkUnits = () => {
    this.setState({
      bookmarkSelectedUnits: []
    });

    if (this.bookmarkModalFormRef) {
      this.bookmarkModalFormRef.setFieldsValue({
        unitsApplied: []
      });
    }
  };

  handleCreateBookmark = () => {
    if (!this.bookmarkModalFormRef) {
      return;
    }

    this.bookmarkModalFormRef.validateFields((err, values) => {
      if (err) {
        return;
      }

      const { rates } = this.state;
      const { selectedPropertyId } = this.props;
      const selectionIndexes = Object.keys(values)
        .map(key => {
          const matched = key.match(/^roomTypesApplied(\d+)$/);
          return matched ? Number(matched[1]) : null;
        })
        .filter(index => index !== null)
        .sort((a, b) => a - b);

      const selections = selectionIndexes.map(index => ({
        roomTypeIds: values['roomTypesApplied' + index] || [],
        unitIds: values['unitsApplied' + index] || []
      }));
      const allRoomTypeIds = Array.from(new Set(selections.flatMap(selection => selection.roomTypeIds)));
      const selectedRoomTypes = rates.filter(roomType => allRoomTypeIds.includes(roomType.id));
      const allUnits = selectedRoomTypes.flatMap(roomType => roomType.units || []);
      const allUnitIds = Array.from(new Set(selections.flatMap(selection => selection.unitIds)));
      const selectedUnits = allUnits.filter(unit => allUnitIds.includes(unit.id));

      const payload = {
        bookmarkName: values.bookmarkName.trim(),
        bookmarks: selections,
        property: selectedPropertyId,
        host: this.getQueryHostId()
      };

      createCalendarBookmark(payload)
        .then(createdBookmark => {
          const mappedBookmark = this.mapApiBookmarkToLocal(createdBookmark);
          mappedBookmark.selections = selections;
          mappedBookmark.roomTypeIds = allRoomTypeIds;
          mappedBookmark.roomTypeNames = selectedRoomTypes.map(roomType => roomType.name);
          mappedBookmark.unitIds = allUnitIds;
          mappedBookmark.unitNames = selectedUnits.map(unit => unit.name);

          this.setState(prevState => ({
            bookmarks: this.reorderPinnedBookmarks([...prevState.bookmarks, mappedBookmark]),
            isBookmarkModalVisible: false
          }));
          this.resetBookmarkModalForm();
          message.success('Bookmark created successfully');
        })
        .catch(error => {
          message.error(error.message || 'Failed to create bookmark');
        });
    });
  };

  handleDeleteBookmark = bookmarkKey => {
    Modal.confirm({
      title: 'Delete Bookmark',
      content: 'Are you sure you want to delete this bookmark?',
      onOk: () => {
        return deleteCalendarBookmark(bookmarkKey)
          .then(() => {
            this.setState(prevState => ({
              bookmarks: prevState.bookmarks.filter(bookmark => bookmark.key !== bookmarkKey)
            }));
            message.success('Bookmark deleted successfully');
          })
          .catch(error => {
            message.error(error.message || 'Failed to delete bookmark');
          });
      }
    });
  };

  reorderPinnedBookmarks = bookmarks => {
    const pinnedBookmarks = bookmarks.filter(bookmark => bookmark.isPinned);
    const unpinnedBookmarks = bookmarks.filter(bookmark => !bookmark.isPinned);
    return [...pinnedBookmarks, ...unpinnedBookmarks];
  };

  handleTogglePinBookmark = bookmarkKey => {
    patchPinCalendarBookmark(bookmarkKey)
      .then(updatedBookmark => {
        const mappedBookmark = this.mapApiBookmarkToLocal(updatedBookmark);
        message.success(mappedBookmark.isPinned ? 'Bookmark pinned successfully' : 'Bookmark unpinned successfully');
        this.setState(prevState => {
          const updatedBookmarks = prevState.bookmarks.map(bookmark => {
            if (bookmark.key === bookmarkKey) {
              return {
                ...bookmark,
                ...mappedBookmark
              };
            }
            return bookmark;
          });

          return {
            bookmarks: this.reorderPinnedBookmarks(updatedBookmarks)
          };
        });
      })
      .catch(error => {
        message.error(error.message || 'Failed to update bookmark pin');
      });
  };

  handleApplyBookmark = bookmark => {
    const { form, isBulkShow } = this.props;
    const firstSelection = bookmark.selections && bookmark.selections.length > 0 ? bookmark.selections[0] : null;

    if (isBulkShow) {
      this.setState({
        bookmarkApplyRequest: {
          ...bookmark,
          applyId: Date.now()
        }
      });
      message.success(`Applied bookmark "${bookmark.name}" to all rate update wizards`);
      return;
    }

    form.setFieldsValue({
      roomTypesApplied: firstSelection ? firstSelection.roomTypeIds : bookmark.roomTypeIds,
      unitsApplied: firstSelection ? firstSelection.unitIds : bookmark.unitIds
    });
    message.success(`Applied bookmark "${bookmark.name}"`);
  };

  render() {
    const { title, isShow, isBulkShow, form, defaultStartDate, defaultEndDate, defaultRoomType, defaultUnit } = this.props;
    const {
      daysOfWeek,
      selectedPropertyName,
      selectedDays,
      rates,
      rateTypes,
      isRateLoading,
      isSaving,
      isBookmarkModalVisible,
      bookmarks,
      bookmarkApplyRequest
    } = this.state;
    const derivedLabelRoomType = intl.get('multicalendar.rateUpdateType.Room Type').d('Room Type');
    const derivedLabelUnit = intl.get('multicalendar.rateUpdateType.Unit').d('Unit');
    const nonWebSources = new Set(['airbnb']);
    const derivedRoomTypes = Array.from(
      new Set(
        (rates || [])
          .filter(rt => Array.isArray(rt.rates))
          .filter(rt =>
            rt.rates.some(r => {
              const hasAirbnb = Array.isArray(r.sources) ? r.sources.some(s => nonWebSources.has(s)) : nonWebSources.has(r.source);
              return hasAirbnb && r.isDerived;
            })
          )
          .map(rt => rt.name)
      )
    );
    const derivedUnits = Array.from(
      new Set(
        (rates || [])
          .flatMap(rt => (Array.isArray(rt.units) ? rt.units : []))
          .filter(
            u =>
              Array.isArray(u.rates) &&
              u.rates.some(r => {
                const hasAirbnb = Array.isArray(r.sources) ? r.sources.some(s => nonWebSources.has(s)) : nonWebSources.has(r.source);
                return hasAirbnb && r.isDerived;
              })
          )
          .map(u => u.name)
      )
    );
    // console.log(rates, 307);
    return (
      <Modal
        style={{ top: 20 }}
        title={`${title} ${intl.get('multicalendar.headerLabels.forProperty').d('for Property:')} ${selectedPropertyName}`}
        visible={isShow || isBulkShow}
        maskClosable={false}
        closable={false}
        destroyOnClose={true}
        width={1200}
        confirmLoading={isSaving}
        // onCancel={this.handleOnCancel}
        footer={[
          <Button id="close-button1-ruw" key="back" loading={isSaving} onClick={this.handleOnCancel}>
            {intl.get('multicalendar.headerLabels.close').d('Close')}
          </Button>,
          <Button id="save-button1-ruw" key="submit" loading={isSaving} onClick={this.handleOnSubmit(false)}>
            {intl.get('multicalendar.headerLabels.save').d('Save')}
          </Button>,
          <Button id="saveclose-button1-ruw" key="submitAndSave" type="primary" loading={isSaving} onClick={this.handleOnSubmit(true)}>
            {intl.get('multicalendar.headerLabels.saveClose').d('Save and Close')}
          </Button>
        ]}
      >
        <Row type="flex" justify="start">
          <Col span={isBulkShow ? 4 : 0}>
            <Row type="flex" align="middle" gutter={16}>
              <Col>
                <Button
                  onClick={this.showBookmarkModal}
                  style={{
                    color: '#00b9c6',
                    borderColor: '#00b9c6'
                  }}
                >
                  Add Bookmark
                </Button>
              </Col>
            </Row>

            <div
              style={{
                marginTop: 8,
                border: '1px solid #f0f0f0',
                borderRadius: 4,
                padding: '8px 10px',
                maxHeight: 420,
                overflowY: 'auto'
              }}
            >
              {bookmarks.length === 0 ? (
                <div style={{ color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>No bookmarks yet.</div>
              ) : (
                bookmarks.map((bookmark, index) => (
                  <Row
                    key={bookmark.key}
                    type="flex"
                    justify="space-between"
                    // align="middle"
                    style={{ marginBottom: bookmarks.length === 1 ? 16 : 8, cursor: 'pointer' }}
                    onClick={() => this.handleApplyBookmark(bookmark)}
                  >
                    <Col span={20}>
                      <div style={{ fontWeight: 500 }}>{bookmark.name}</div>
                      {/* <div style={{ fontSize: 11, color: 'rgba(0,0,0,0.45)' }}>
                        {(bookmark.selections && bookmark.selections.length > 0 ? `${bookmark.selections.length} selection sets, ` : '') +
                          `${bookmark.roomTypeIds.length} room types, ${bookmark.unitIds.length} units`}
                      </div> */}
                    </Col>
                    <Col span={4} style={{ textAlign: 'right', display: 'flex', flexDirection: 'row' }}>
                      <Icon
                        type="pushpin"
                        theme={bookmark.isPinned ? 'filled' : 'outlined'}
                        onClick={e => {
                          e.stopPropagation();
                          this.handleTogglePinBookmark(bookmark.key);
                        }}
                        style={{ color: bookmark.isPinned ? '#faad14' : 'rgba(0,0,0,0.45)', cursor: 'pointer', marginRight: 8 }}
                      />
                      <Icon
                        type="delete"
                        onClick={e => {
                          e.stopPropagation();
                          this.handleDeleteBookmark(bookmark.key);
                        }}
                        style={{ color: '#ff4d4f', cursor: 'pointer' }}
                      />
                    </Col>

                    {index !== bookmarks.length - 1 && (
                      <Col span={24}>
                        <Divider style={{ margin: '16px 0px' }} />
                      </Col>
                    )}
                  </Row>
                ))
              )}
            </div>
          </Col>

          <Col
            span={isBulkShow ? 1 : 0}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div
              style={{
                backgroundColor: 'rgba(0,0,0,0.15)',
                width: 1,
                height: '100%'
              }}
            />
          </Col>

          <Col span={isBulkShow ? 19 : 24}>
            <Form onSubmit={this.handleOnSubmit}>
              {(derivedRoomTypes.length > 0 || derivedUnits.length > 0) && (
                <div style={{ marginBottom: 12 }}>
                  {derivedRoomTypes.length > 0 && (
                    <Alert
                      type="warning"
                      showIcon
                      message={
                        <span>
                          {intl
                            .getHTML('multicalendar.headerLabels.derivedInfo', { label: derivedLabelRoomType })
                            .d(
                              `There are some ${derivedLabelRoomType}s using <strong>Derived Rate</strong> and those ${derivedLabelRoomType}s price will derive from Web Rate Price instead.`
                            )}
                          <Tooltip
                            placement="right"
                            title={
                              <div>
                                <p>
                                  {intl
                                    .getHTML('multicalendar.headerLabels.derivedInfo2', { label: derivedLabelRoomType })
                                    .d(`These ${derivedLabelRoomType}s are using derived rate:`)}
                                </p>
                                <ul>
                                  {derivedRoomTypes.slice(0, 6).map(name => (
                                    <li key={name}>{name}</li>
                                  ))}
                                  {derivedRoomTypes.length > 6 && (
                                    <span style={{ color: '#1890ff' }}>{`${intl.get('multicalendar.headerLabels.viewAll').d('View all')} ${
                                      derivedRoomTypes.length
                                    } ${derivedLabelRoomType}s`}</span>
                                  )}
                                </ul>
                              </div>
                            }
                          >
                            <Icon type="question-circle" style={{ marginLeft: 6 }} />
                          </Tooltip>
                        </span>
                      }
                    />
                  )}
                  {derivedUnits.length > 0 && (
                    <div style={{ marginTop: 8 }}>
                      <Alert
                        type="warning"
                        showIcon
                        message={
                          <span>
                            {intl
                              .getHTML('multicalendar.headerLabels.derivedInfo', { label: derivedLabelUnit })
                              .d(
                                `There are some ${derivedLabelUnit}s using <strong>Derived Rate</strong> and those ${derivedLabelUnit}s price will derive from Web Rate Price instead.`
                              )}
                            <Tooltip
                              placement="right"
                              title={
                                <div>
                                  <p>
                                    {intl
                                      .getHTML('multicalendar.headerLabels.derivedInfo2', { label: derivedLabelUnit })
                                      .d(`These ${derivedLabelUnit}s are using derived rate:`)}
                                  </p>
                                  <ul>
                                    {derivedUnits.slice(0, 6).map(name => (
                                      <li key={name}>{name}</li>
                                    ))}
                                    {derivedUnits.length > 6 && (
                                      <span style={{ color: '#1890ff' }}>{`${intl.get('multicalendar.headerLabels.viewAll').d('View all')} ${
                                        derivedUnits.length
                                      } ${derivedLabelUnit}s`}</span>
                                    )}
                                  </ul>
                                </div>
                              }
                            >
                              <Icon type="question-circle" style={{ marginLeft: 6 }} />
                            </Tooltip>
                          </span>
                        }
                      />
                    </div>
                  )}
                </div>
              )}
              {isRateLoading ? (
                <Skeleton loading={isRateLoading} />
              ) : isShow ? (
                <MCRateUpdateBody
                  form={form}
                  roomTypesWithRatesAndUnits={rates}
                  rateTypes={rateTypes}
                  daySelections={daysOfWeek}
                  selectedDays={selectedDays}
                  defaultStartDate={defaultStartDate}
                  defaultEndDate={defaultEndDate}
                  defaultRoomType={defaultRoomType}
                  defaultUnit={defaultUnit}
                  onSelectedDayChange={this.handleSelectedDayChange}
                  currency={this.props.currency}
                  timezone={this.props.timezone}
                />
              ) : isBulkShow ? (
                <BulkMCRateUpdateBody
                  form={form}
                  roomTypesWithRatesAndUnits={rates}
                  rateTypes={rateTypes}
                  applyBookmarkRequest={bookmarkApplyRequest}
                  daySelections={daysOfWeek}
                  selectedDays={selectedDays}
                  defaultStartDate={defaultStartDate}
                  defaultEndDate={defaultEndDate}
                  defaultRoomType={defaultRoomType}
                  defaultUnit={defaultUnit}
                  onSelectedDayChange={this.handleSelectedDayChange}
                  currency={this.props.currency}
                  timezone={this.props.timezone}
                />
              ) : null}
            </Form>
          </Col>
        </Row>
        <Modal
          title="Add Bookmark"
          visible={isBookmarkModalVisible}
          onCancel={this.hideBookmarkModal}
          onOk={this.handleCreateBookmark}
          maskClosable={false}
          destroyOnClose
          width={900}
          okText="Add Bookmark"
        >
          <BookmarkModalForm
            wrappedComponentRef={this.setBookmarkModalFormRef}
            roomTypesWithRatesAndUnits={rates}
            rateTypes={rateTypes}
            currency={this.props.currency}
            timezone={this.props.timezone}
          />
        </Modal>
      </Modal>
    );
  }
}

MCModalRateUpdateWizard.propTypes = {
  form: PropTypes.object.isRequired,
  isShow: PropTypes.bool,
  isBulkShow: PropTypes.bool,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  selectedPropertyId: PropTypes.string.isRequired,
  selectedRateFilters: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  defaultStartDate: PropTypes.string,
  defaultEndDate: PropTypes.string,
  currency: PropTypes.string,
  timezone: PropTypes.string
};

MCModalRateUpdateWizard.defaultProps = {
  form: {},
  isShow: false,
  isBulkShow: false,
  onCancel: () => {},
  onSuccess: () => {},
  selectedRateFilters: [],
  title: 'Update Rate Wizard'
};

export default withRouter(Form.create()(MCModalRateUpdateWizard));
